import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './QsrIndicator.styles'

/**
 * generic qsr indicator
 * @param props
 * @param rest
 * @returns {*}
 * @constructor
 */
const QsrIndicator = ({ currentLevel, maxLevel, size, iconClass, ...rest }) => {
  const indicator = () => {
    const qsr = []

    for (let i = 1; i <= maxLevel; i += 1) {
      qsr.push(
        <Styled.CircleSpacer key={ i }>
          <Styled.Circle
            size={ size }
            active={ i <= currentLevel }
            className={ iconClass }
          />
        </Styled.CircleSpacer>
      )
    }

    return qsr
  }

  return <Styled.Container { ...rest }>{indicator()}</Styled.Container>
}

QsrIndicator.defaultProps = {
  maxLevel: 3,
  size: 20,
  iconClass: 'icon-l-qsr-general',
}

QsrIndicator.propTypes = {
  /* current qsr level */
  currentLevel: PropTypes.number.isRequired,
  /* current qsr level */
  iconClass: PropTypes.string,
  /* maximal levels */
  maxLevel: PropTypes.number,
  /* size for the circles */
  size: PropTypes.number,
}

export default QsrIndicator
